import { useContext, useRef } from 'react';
import ToastContext from './context.js';

const DEFAULT_TIMEOUT = 5000;
function useToast() {
  const context = useContext(ToastContext);
  const lastToastRef = useRef('');
  const showToast = (message, type, timeout, onClose, action) => {
    const toastId = context.showToast(message, type, timeout || DEFAULT_TIMEOUT, onClose, action);
    lastToastRef.current = toastId;
    return toastId;
  };

  // This function receives a optional toastId, if not passed in it will by default hide the LAST opened toast
  const hideToast = function () {
    let toastId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : lastToastRef.current;
    context.hideToast(toastId);
  };
  return [showToast, hideToast];
}

export { useToast as default };
//# sourceMappingURL=useToast.js.map
